import { EOFExceptionh831u25jcq9n as EOFException } from './-PlatformJs.mjs';
import {
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  IndexOutOfBoundsException1qfr429iumro0 as IndexOutOfBoundsException,
} from '../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  subtract2orl8z9upxd9l as subtract,
  add2suhfggl4zvkk as add,
  fromInt2ii0rejb1w62w as fromInt,
  convertToInty04h231mmjoh as convertToInt,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { toShort36kaw0zjdq3ex as toShort } from '../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import {
  checkBoundsw7d8y6z7j2xc as checkBounds,
  checkOffsetAndCountazlu23xkuwoi as checkOffsetAndCount,
  get_HEX_DIGIT_CHARS28oau3fmf5vf6 as get_HEX_DIGIT_CHARS,
} from './-Util.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isEmpty39cntv762vey6 as isEmpty } from './Segment.mjs';
import { PeekSource3frbthc9yehpr as PeekSource } from './PeekSource.mjs';
import { buffered3kq86cdmguv3h as buffered } from './Core.mjs';
import { SegmentPool_instanceps1mclk6cv3l as SegmentPool_instance } from './SegmentPool.mjs';
import {
  write$defaultuw5a81aphnfp as write$default,
  Sink189iybvk4puo6 as Sink,
} from './Sink.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  UnsafeBufferOperations_instance3ib8lrmu0w6c5 as UnsafeBufferOperations_instance,
  get_SegmentReadContextImpl28xxxurlbcmul as get_SegmentReadContextImpl,
} from './unsafe/UnsafeBufferOperations.mjs';
import { _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx } from '../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Source1shr0ps16u4p4 as Source } from './Source.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function throwEof($this, byteCount) {
  throw EOFException().c4f("Buffer doesn't contain required number of bytes (size: " + $this.q2().toString() + ', required: ' + byteCount.toString() + ')');
}
var BufferClass;
function Buffer() {
  if (BufferClass === VOID) {
    class $ {
      constructor() {
        this.w4e_1 = null;
        this.x4e_1 = null;
        this.y4e_1 = 0n;
      }
      q2() {
        return this.y4e_1;
      }
      d3y() {
        return this;
      }
      e3y() {
        return this.q2() === 0n;
      }
      f3y(byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount: ' + byteCount.toString();
          throw IllegalArgumentException().n2(toString(message));
        }
        if (this.q2() < byteCount) {
          throw EOFException().c4f("Buffer doesn't contain required number of bytes (size: " + this.q2().toString() + ', required: ' + byteCount.toString() + ')');
        }
      }
      k3y(byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount: ' + byteCount.toString() + ' < 0';
          throw IllegalArgumentException().n2(toString(message));
        }
        return this.q2() >= byteCount;
      }
      n3y() {
        var tmp0_elvis_lhs = this.w4e_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throwEof(this, 1n);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var segment = tmp;
        var segmentSize = segment.q2();
        if (segmentSize === 0) {
          this.k4f();
          return this.n3y();
        }
        var v = segment.l4f();
        this.y4e_1 = subtract(this.y4e_1, 1n);
        if (segmentSize === 1) {
          this.k4f();
        }
        return v;
      }
      m4f() {
        var tmp0_elvis_lhs = this.w4e_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          throwEof(this, 2n);
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var segment = tmp;
        var segmentSize = segment.q2();
        if (segmentSize < 2) {
          this.f3y(2n);
          if (segmentSize === 0) {
            this.k4f();
            return this.m4f();
          }
          // Inline function 'kotlinx.io.and' call
          var tmp_0 = (this.n3y() & 255) << 8;
          // Inline function 'kotlinx.io.and' call
          var tmp$ret$1 = this.n3y() & 255;
          return toShort(tmp_0 | tmp$ret$1);
        }
        var v = segment.n4f();
        this.y4e_1 = subtract(this.y4e_1, 2n);
        if (segmentSize === 2) {
          this.k4f();
        }
        return v;
      }
      o4f() {
        return Unit_instance;
      }
      p4f(out, startIndex, endIndex) {
        checkBounds(this.q2(), startIndex, endIndex);
        if (startIndex === endIndex)
          return Unit_instance;
        var currentOffset = startIndex;
        var remainingByteCount = subtract(endIndex, startIndex);
        out.y4e_1 = add(out.y4e_1, remainingByteCount);
        var s = this.w4e_1;
        while (currentOffset >= fromInt(ensureNotNull(s).f4f_1 - s.e4f_1 | 0)) {
          currentOffset = subtract(currentOffset, fromInt(s.f4f_1 - s.e4f_1 | 0));
          s = s.i4f_1;
        }
        while (remainingByteCount > 0n) {
          var copy = ensureNotNull(s).q4f();
          copy.e4f_1 = copy.e4f_1 + convertToInt(currentOffset) | 0;
          var tmp = copy;
          var tmp0 = copy.e4f_1 + convertToInt(remainingByteCount) | 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b = copy.f4f_1;
          tmp.f4f_1 = Math.min(tmp0, b);
          // Inline function 'kotlinx.io.Buffer.pushSegment' call
          if (out.w4e_1 == null) {
            out.w4e_1 = copy;
            out.x4e_1 = copy;
          } else if (false) {
            out.x4e_1 = ensureNotNull(out.x4e_1).r4f(copy).s4f();
            if (ensureNotNull(out.x4e_1).j4f_1 == null) {
              out.w4e_1 = out.x4e_1;
            }
          } else {
            out.x4e_1 = ensureNotNull(out.x4e_1).r4f(copy);
          }
          remainingByteCount = subtract(remainingByteCount, fromInt(copy.f4f_1 - copy.e4f_1 | 0));
          currentOffset = 0n;
          s = s.i4f_1;
        }
      }
      t4f() {
        var result = this.q2();
        if (result === 0n)
          return 0n;
        var tail = ensureNotNull(this.x4e_1);
        if (tail.f4f_1 < 8192 && tail.h4f_1) {
          result = subtract(result, fromInt(tail.f4f_1 - tail.e4f_1 | 0));
        }
        return result;
      }
      a3x(position) {
        if (position < 0n || position >= this.q2()) {
          throw IndexOutOfBoundsException().i3('position (' + position.toString() + ') is not within the range [0..size(' + this.q2().toString() + '))');
        }
        if (position === 0n) {
          return ensureNotNull(this.w4e_1).u4f(0);
        }
        $l$block_1: {
          // Inline function 'kotlinx.io.seek' call
          if (this.w4e_1 == null) {
            return ensureNotNull(null).u4f(convertToInt(subtract(position, -1n)));
          }
          if (subtract(this.q2(), position) < position) {
            var s = this.x4e_1;
            var offset = this.q2();
            $l$loop: while (!(s == null) && offset > position) {
              offset = subtract(offset, fromInt(s.f4f_1 - s.e4f_1 | 0));
              if (offset <= position)
                break $l$loop;
              s = s.j4f_1;
            }
            var tmp0 = s;
            var offset_0 = offset;
            return ensureNotNull(tmp0).u4f(convertToInt(subtract(position, offset_0)));
          } else {
            var s_0 = this.w4e_1;
            var offset_1 = 0n;
            $l$loop_0: while (!(s_0 == null)) {
              var tmp0_0 = offset_1;
              // Inline function 'kotlin.Long.plus' call
              var other = s_0.f4f_1 - s_0.e4f_1 | 0;
              var nextOffset = add(tmp0_0, fromInt(other));
              if (nextOffset > position)
                break $l$loop_0;
              s_0 = s_0.i4f_1;
              offset_1 = nextOffset;
            }
            var tmp0_1 = s_0;
            var offset_2 = offset_1;
            return ensureNotNull(tmp0_1).u4f(convertToInt(subtract(position, offset_2)));
          }
        }
      }
      a5() {
        return this.o3v(this.q2());
      }
      o3v(byteCount) {
        // Inline function 'kotlinx.io.checkByteCount' call
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount (' + byteCount.toString() + ') < 0';
          throw IllegalArgumentException().n2(toString(message));
        }
        var remainingByteCount = byteCount;
        while (remainingByteCount > 0n) {
          var tmp0_elvis_lhs = this.w4e_1;
          var tmp;
          if (tmp0_elvis_lhs == null) {
            throw EOFException().c4f('Buffer exhausted before skipping ' + byteCount.toString() + ' bytes.');
          } else {
            tmp = tmp0_elvis_lhs;
          }
          var head = tmp;
          var tmp0 = remainingByteCount;
          // Inline function 'kotlinx.io.minOf' call
          var b = head.f4f_1 - head.e4f_1 | 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b_0 = fromInt(b);
          var tmp$ret$3 = tmp0 <= b_0 ? tmp0 : b_0;
          var toSkip = convertToInt(tmp$ret$3);
          this.y4e_1 = subtract(this.y4e_1, fromInt(toSkip));
          remainingByteCount = subtract(remainingByteCount, fromInt(toSkip));
          head.e4f_1 = head.e4f_1 + toSkip | 0;
          if (head.e4f_1 === head.f4f_1) {
            this.k4f();
          }
        }
      }
      v4f(sink, startIndex, endIndex) {
        // Inline function 'kotlinx.io.checkBounds' call
        var size = sink.length;
        checkBounds(fromInt(size), fromInt(startIndex), fromInt(endIndex));
        var tmp0_elvis_lhs = this.w4e_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return -1;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var s = tmp;
        var tmp0 = endIndex - startIndex | 0;
        // Inline function 'kotlin.comparisons.minOf' call
        var b = s.q2();
        var toCopy = Math.min(tmp0, b);
        s.w4f(sink, startIndex, startIndex + toCopy | 0);
        this.y4e_1 = subtract(this.y4e_1, fromInt(toCopy));
        if (isEmpty(s)) {
          this.k4f();
        }
        return toCopy;
      }
      x4f(sink, byteCount) {
        // Inline function 'kotlinx.io.checkByteCount' call
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount (' + byteCount.toString() + ') < 0';
          throw IllegalArgumentException().n2(toString(message));
        }
        if (this.q2() === 0n)
          return -1n;
        var bytesWritten = byteCount > this.q2() ? this.q2() : byteCount;
        sink.y4f(this, bytesWritten);
        return bytesWritten;
      }
      z4f(sink, byteCount) {
        // Inline function 'kotlinx.io.checkByteCount' call
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount (' + byteCount.toString() + ') < 0';
          throw IllegalArgumentException().n2(toString(message));
        }
        if (this.q2() < byteCount) {
          sink.y4f(this, this.q2());
          throw EOFException().c4f('Buffer exhausted before writing ' + byteCount.toString() + ' bytes. Only ' + this.q2().toString() + ' bytes were written.');
        }
        sink.y4f(this, byteCount);
      }
      a4g(sink) {
        var byteCount = this.q2();
        if (byteCount > 0n) {
          sink.y4f(this, byteCount);
        }
        return byteCount;
      }
      i40() {
        return buffered(new (PeekSource())(this));
      }
      b4g(minimumCapacity) {
        // Inline function 'kotlin.require' call
        if (!(minimumCapacity >= 1 && minimumCapacity <= 8192)) {
          var message = 'unexpected capacity (' + minimumCapacity + '), should be in range [1, 8192]';
          throw IllegalArgumentException().n2(toString(message));
        }
        if (this.x4e_1 == null) {
          var result = SegmentPool_instance.r3w();
          this.w4e_1 = result;
          this.x4e_1 = result;
          return result;
        }
        var t = ensureNotNull(this.x4e_1);
        if ((t.f4f_1 + minimumCapacity | 0) > 8192 || !t.h4f_1) {
          var newTail = t.r4f(SegmentPool_instance.r3w());
          this.x4e_1 = newTail;
          return newTail;
        }
        return t;
      }
      e4g(source, startIndex, endIndex) {
        // Inline function 'kotlinx.io.checkBounds' call
        var size = source.length;
        checkBounds(fromInt(size), fromInt(startIndex), fromInt(endIndex));
        var currentOffset = startIndex;
        while (currentOffset < endIndex) {
          var tail = this.b4g(1);
          var tmp0 = endIndex - currentOffset | 0;
          // Inline function 'kotlin.comparisons.minOf' call
          var b = tail.f4g();
          var toCopy = Math.min(tmp0, b);
          tail.g4g(source, currentOffset, currentOffset + toCopy | 0);
          currentOffset = currentOffset + toCopy | 0;
        }
        var tmp = this;
        var tmp0_0 = this.y4e_1;
        // Inline function 'kotlin.Long.plus' call
        var other = endIndex - startIndex | 0;
        tmp.y4e_1 = add(tmp0_0, fromInt(other));
      }
      y4f(source, byteCount) {
        // Inline function 'kotlin.require' call
        if (!!(source === this)) {
          var message = 'source == this';
          throw IllegalArgumentException().n2(toString(message));
        }
        checkOffsetAndCount(source.y4e_1, 0n, byteCount);
        var remainingByteCount = byteCount;
        while (remainingByteCount > 0n) {
          if (remainingByteCount < fromInt(ensureNotNull(source.w4e_1).q2())) {
            var tail = this.x4e_1;
            var tmp;
            if (!(tail == null) && tail.h4f_1) {
              var tmp0 = remainingByteCount;
              // Inline function 'kotlin.Long.plus' call
              var other = tail.f4f_1;
              var tmp0_0 = add(tmp0, fromInt(other));
              // Inline function 'kotlin.Long.minus' call
              var other_0 = tail.i4g() ? 0 : tail.e4f_1;
              tmp = subtract(tmp0_0, fromInt(other_0)) <= 8192n;
            } else {
              tmp = false;
            }
            if (tmp) {
              ensureNotNull(source.w4e_1).k4g(tail, convertToInt(remainingByteCount));
              source.y4e_1 = subtract(source.y4e_1, remainingByteCount);
              this.y4e_1 = add(this.y4e_1, remainingByteCount);
              return Unit_instance;
            } else {
              source.w4e_1 = ensureNotNull(source.w4e_1).j4g(convertToInt(remainingByteCount));
            }
          }
          var segmentToMove = ensureNotNull(source.w4e_1);
          var movedByteCount = fromInt(segmentToMove.q2());
          source.w4e_1 = segmentToMove.l4g();
          if (source.w4e_1 == null) {
            source.x4e_1 = null;
          }
          // Inline function 'kotlinx.io.Buffer.pushSegment' call
          if (this.w4e_1 == null) {
            this.w4e_1 = segmentToMove;
            this.x4e_1 = segmentToMove;
          } else if (true) {
            this.x4e_1 = ensureNotNull(this.x4e_1).r4f(segmentToMove).s4f();
            if (ensureNotNull(this.x4e_1).j4f_1 == null) {
              this.w4e_1 = this.x4e_1;
            }
          } else {
            this.x4e_1 = ensureNotNull(this.x4e_1).r4f(segmentToMove);
          }
          source.y4e_1 = subtract(source.y4e_1, movedByteCount);
          this.y4e_1 = add(this.y4e_1, movedByteCount);
          remainingByteCount = subtract(remainingByteCount, movedByteCount);
        }
      }
      m4g(source) {
        var totalBytesRead = 0n;
        $l$loop: while (true) {
          var readCount = source.x4f(this, 8192n);
          if (readCount === -1n)
            break $l$loop;
          totalBytesRead = add(totalBytesRead, readCount);
        }
        return totalBytesRead;
      }
      n4g(byte) {
        this.b4g(1).o4g(byte);
        this.y4e_1 = add(this.y4e_1, 1n);
      }
      p4g(short) {
        this.b4g(2).q4g(short);
        this.y4e_1 = add(this.y4e_1, 2n);
      }
      l6() {
        return Unit_instance;
      }
      toString() {
        if (this.q2() === 0n)
          return 'Buffer(size=0)';
        var maxPrintableBytes = 64;
        // Inline function 'kotlinx.io.minOf' call
        var b = this.q2();
        // Inline function 'kotlin.comparisons.minOf' call
        var a = fromInt(maxPrintableBytes);
        var tmp$ret$0 = a <= b ? a : b;
        var len = convertToInt(tmp$ret$0);
        var builder = StringBuilder().tb(imul(len, 2) + (this.q2() > fromInt(maxPrintableBytes) ? 1 : 0) | 0);
        var bytesWritten = 0;
        // Inline function 'kotlinx.io.unsafe.UnsafeBufferOperations.forEachSegment' call
        var curr = this.w4e_1;
        while (!(curr == null)) {
          var tmp0 = get_SegmentReadContextImpl();
          var segment = curr;
          var idx = 0;
          while (bytesWritten < len && idx < segment.q2()) {
            var _unary__edvuaz = idx;
            idx = _unary__edvuaz + 1 | 0;
            var b_0 = tmp0.r4g(segment, _unary__edvuaz);
            bytesWritten = bytesWritten + 1 | 0;
            var tmp = get_HEX_DIGIT_CHARS();
            // Inline function 'kotlinx.io.shr' call
            var tmp$ret$4 = b_0 >> 4;
            var tmp_0 = builder.o1(tmp[tmp$ret$4 & 15]);
            var tmp_1 = get_HEX_DIGIT_CHARS();
            // Inline function 'kotlinx.io.and' call
            var tmp$ret$5 = b_0 & 15;
            tmp_0.o1(tmp_1[tmp$ret$5]);
          }
          curr = curr.i4f_1;
        }
        if (this.q2() > fromInt(maxPrintableBytes)) {
          builder.o1(_Char___init__impl__6a9atx(8230));
        }
        return 'Buffer(size=' + this.q2().toString() + ' hex=' + builder.toString() + ')';
      }
      k4f() {
        var oldHead = ensureNotNull(this.w4e_1);
        var nextHead = oldHead.i4f_1;
        this.w4e_1 = nextHead;
        if (nextHead == null) {
          this.x4e_1 = null;
        } else {
          nextHead.j4f_1 = null;
        }
        oldHead.i4f_1 = null;
        SegmentPool_instance.s4g(oldHead);
      }
      t4g() {
        var oldTail = ensureNotNull(this.x4e_1);
        var newTail = oldTail.j4f_1;
        this.x4e_1 = newTail;
        if (newTail == null) {
          this.w4e_1 = null;
        } else {
          newTail.i4f_1 = null;
        }
        oldTail.j4f_1 = null;
        SegmentPool_instance.s4g(oldTail);
      }
    }
    protoOf($).h4g = write$default;
    initMetadataForClass($, 'Buffer', Buffer, VOID, [Source(), Sink()]);
    BufferClass = $;
  }
  return BufferClass;
}
//region block: exports
export {
  Buffer as Buffergs925ekssbch,
};
//endregion

//# sourceMappingURL=Buffer.mjs.map
